import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MyDatePicker, IMyDpOptions, IMyDateModel } from "mydatepicker";
import { AppService } from "../services/app.service";
import { ModalDirective } from "ngx-bootstrap/modal";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { SupportService } from "../services/support-service";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { HomeSelectionSharedService } from "../services/home-selection-shared.service";

@Component({
  selector: "app-schedule-form",
  templateUrl: "./schedule-form.component.html",
  styleUrls: ["./schedule-form.component.scss"],
})
export class ScheduleFormComponent implements OnInit {
  @ViewChild("mydp") mydp: MyDatePicker;
  @ViewChild("autoShownModal") template: ModalDirective;
  @ViewChild("examModal") examModal: TemplateRef<any>;
  @ViewChild("bodyPartModal") bodyPartModal: TemplateRef<any>;
  @ViewChild("ProcedureModal") ProcedureModal: TemplateRef<any>;
  @ViewChild("insuranceModal") insuranceModal: TemplateRef<any>;
  @ViewChild("insuranceTypeModal") insuranceTypeModal: TemplateRef<any>;

  selected3 = false;
  modalRef: BsModalRef;
  showProcedure = false;
  fromdonebutton = false;
  showErrDate = false;
  cptcodeobject: any;
  insuranceList: any = [];
  allExamList: any = [];
  bodypartsList: any = [];
  procedureList: any = [];
  isExist = false;
  timeZone = 0;
  dayOfweek = "";
  timezone_offset_min: any;
  offset_hrs: any;
  offset_min: any;
  public myDatePickerOptions: IMyDpOptions = {};
  public today = new Date();
  path: any;
  scheduleappointmentid: any = "";
  homeDate: any;
  homeDatePlaceHolder: any;
  homeLocation: any;
  paymode: any;
  homeLocationPlaceholder: any = "Location";
  homeInsurance: any = "";
  homeInsuranceType: any = "";
  homeExamId: any = "";
  homeBodyPartId: any = "";
  homeProcedureName: any = "";
  selectedlang: any = [];
  countryCode: any = "US";
  placeholerCptCode: any = "CPT Code";
  homeExamName: any = "";
  homeBodyPartName: any = "";
  homeCptCode: any = "";
  homeinfosubmit = false;
  multiplePro = false;
  selectProcedureList: any = [];
  addProcedureList: any = [];
  cptCodeList: any = [];
  notfilled = false;
  scheduledData: any = {};
  disabledInsType = false;
  payMode: any = "insurance";
  currentDate: number;
  currentMonth: number;
  currentYear: number;
  blockAddMultipleProcedure = true;
  homeinfosubmitNew = false;
  showAddProcedureFormMob = false;
  searchSelectBodyPart = "";
  searchSelectExam = "";
  searchSelectProcedure = "";

  constructor(
    private supportService: SupportService,
    private modalService: BsModalService,
    private datePipe: DatePipe,
    private router: Router,
    private schedueBuilder: FormBuilder,
    private appservice: AppService,
    private toastr: ToastrService,
    private homeSelectionShared: HomeSelectionSharedService
  ) {}

  lat: any;
  lng: any;
  homeInsuranceName = "";
  homeInsuranceTypeName = "";
  ngOnInit() {
    this.supportService.showback.next(true);
    this.path = this.router.url;
    const Splitpath = this.path.split("/");
    if (Splitpath && Splitpath.length === 3) {
      this.scheduleappointmentid = Splitpath[2];
    }
    if (sessionStorage.getItem("scheduleData")) {
      this.scheduledData = JSON.parse(sessionStorage.getItem("scheduleData"));
      if (this.scheduledData.payMode === "self") {
        this.homeInsurance = "self";
        this.homeInsuranceName = "self";
        this.homeInsuranceType = "";
        this.homeInsuranceTypeName = "";
      } else {
        this.homeInsurance = this.scheduledData.insuranceId
          ? this.scheduledData.insuranceId
          : "";
        this.homeInsuranceName = this.scheduledData.homeInsuranceName;
        this.homeInsuranceType = this.scheduledData.inType;
        this.homeInsuranceTypeName =
          this.scheduledData.inType === 2 ? "HMO" : "PPO";
      }
      this.homeDate = this.formatHomeDateStr(this.scheduledData.scheduleOn);
      this.homeDatePlaceHolder = this.formatHomeDateStr(
        this.scheduledData.scheduleOn
      );
      this.homeExamId = this.scheduledData.selectedExamId;
      this.homeLocation = this.scheduledData.location;
      this.homeLocationPlaceholder = "Location";
      this.lat = this.scheduledData.latitude;
      this.lng = this.scheduledData.longitude;
      this.countryCode = this.scheduledData.countryCode;
      this.getallinsurancebyCountryCode(this.countryCode);
      this.selectProcedureList = [];
      this.selectProcedureList = this.scheduledData.selectProcedureList;
      if (this.selectProcedureList && this.selectProcedureList.length >= 5) {
        this.showAddProcedureFormMob = false;
      } else {
        this.showAddProcedureFormMob = true;
      }
    }
    this.getLanguage();
    this.getallexams();
    if (this.homeExamId) {
      this.getallbodypartsbyexamid();
    }
    this.currentDate = this.today.getDate() - 1;
    this.currentMonth = this.today.getMonth() + 1;
    this.currentYear = this.today.getFullYear();
    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      minYear: +this.currentYear,
      firstDayOfWeek: "su",
      disableUntil: {
        year: +this.currentYear,
        month: +this.currentMonth,
        day: +this.currentDate,
      },
      maxYear: +this.currentYear,
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: false,
      inline: false,
    };

    this.addProcedureList.examId = "";
    this.addProcedureList.bodyPartId = "";
    this.addProcedureList.bodyPartName = "";
    this.addProcedureList.cptCode = "";
    this.addProcedureList.procedureName = "";
    this.addProcedureList.procedureId = "";
    this.addProcedureList.procedureList = [];
    this.addProcedureList.procedureSelected = "";
  }

  openpopup() {
    setTimeout(() => {
      if (!this.homeBodyPartName) {
        this.openBodyPartModal();
      } else if (!this.homeProcedureName) {
        this.openProcedureModal();
      }
    }, 100);
  }

  selectInsuranceValue(insurance) {
    if (insurance === "self") {
      this.homeInsurance = "self";
      this.homeInsuranceName = "Self Pay";
      this.homeInsuranceTypeName = "";
    } else {
      this.homeInsurance = insurance.id;
      this.homeInsuranceName = insurance.name;
    }
    this.modalRef.hide();
    this.changeHomeInsurance(insurance);
  }

  selectInsuranceTypeValue(type, name) {
    this.homeInsuranceType = type;
    this.homeInsuranceTypeName = name;
    this.modalRef.hide();
  }

  selectAddress() {
    const ele = document.querySelectorAll(".pac-container");
    if (ele.length > 0) {
      ele.forEach((element, index) => {
        ele[index].setAttribute(
          "class",
          "pac-container pac-logo hdpi schedule-form-top"
        );
      });
    }
  }

  openInsuranceModal() {
    this.openModal(this.insuranceModal);
  }

  openInsuranceTypeModal() {
    this.openModal(this.insuranceTypeModal);
  }

  openExamModal() {
    this.openModal(this.examModal);
  }

  selectExamValue(exam) {
    this.addProcedureList.examId = exam.id;
    this.homeExamName = exam.examshortname;
    this.addProcedureList.bodyPartId = "";
    this.homeBodyPartName = "";
    this.homeProcedureName = "";
    this.addProcedureList.bodyPartList = [];
    this.getallbodypartsbyexamidNew(exam.id, 0);
    this.modalRef.hide();
    this.openpopup();
  }

  openBodyPartModal() {
    if (this.homeExamName) {
      this.openModal(this.bodyPartModal);
    }
  }

  selectBodyPartValue(bodyPart) {
    this.addProcedureList.bodyPartId = bodyPart.id;
    this.homeBodyPartName = bodyPart.bodyPart;
    this.homeProcedureName = "";
    this.getallproceduresbybodypartNew(bodyPart.id, 0);
    this.modalRef.hide();
    this.openpopup();
  }

  openProcedureModal() {
    if (this.homeBodyPartName) {
      this.openModal(this.ProcedureModal);
    }
  }

  changeHomeCptCode(procedure) {
    return this.homeSelectionShared.changeHomeCptCode(this, procedure);
  }

  getallbodypartsbyexamidNew(examid, index) {
    const data = {
      examId: examid,
    };
    this.addProcedureList.examId = examid;
    this.appservice.getallbodypartsbyexamid(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.addProcedureList.bodyPartList = res["entity"];
          this.addProcedureList.bodyPartId = "";
          this.addProcedureList.procedureList = [];
          if (this.allExamList && this.allExamList.length > 0) {
            for (let i = 0; i < this.allExamList.length; i++) {
              if (this.allExamList[i].id === this.addProcedureList.examId) {
                this.addProcedureList.examName = this.allExamList[
                  i
                ].examshortname;
                break;
              }
            }
          }
          this.blockAddMultipleProcedure = false;
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallproceduresbybodypartNew(bodypartId, index) {
    const data = {
      bodypartId: bodypartId,
    };
    this.appservice.getallproceduresbybodypart(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.addProcedureList.procedureList = res["entity"];
          if (
            this.addProcedureList.bodyPartList &&
            this.addProcedureList.bodyPartList.length > 0
          ) {
            for (
              let i = 0;
              i < this.addProcedureList.bodyPartList.length;
              i++
            ) {
              if (this.addProcedureList.bodyPartList[i].id === bodypartId) {
                this.addProcedureList.bodyPartName = this.addProcedureList.bodyPartList[
                  i
                ].bodyPart;
                break;
              }
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  setAllProcedureValueNew(procedure) {
    let isExist = false;
    if (this.selectProcedureList && this.selectProcedureList.length > 0) {
      for (let s = 0; s < this.selectProcedureList.length; s++) {
        if (this.selectProcedureList[s].cptCode === procedure.cptCode) {
          isExist = true;
          break;
        }
      }
    }
    if (!isExist) {
      this.addProcedureList.procedureSelected = procedure;
      this.homeProcedureName = procedure.procedureName;
      this.homeCptCode = procedure.cptCode;
      this.blockAddMultipleProcedure = false;
      this.modalRef.hide();
    } else {
      this.blockAddMultipleProcedure = true;
      this.homeProcedureName = "";
      this.homeCptCode = "";
      this.toastr.error("Procedure already selected");
    }
  }

  addNewProcedureList(list) {
    this.homeinfosubmitNew = true;
    if (list && list.examId && list.bodyPartId && list.procedureSelected) {
      this.selectProcedureList.push({
        examId: list.examId,
        bodyPartList: list.bodyPartList,
        bodyPartId: list.bodyPartId,
        procedureList: list.procedureSelected,
        cptCode: list.procedureSelected.cptCode,
        bodyPartName: list.bodyPartName,
        examName: list.examName,
        procedureName: list.procedureSelected.procedureName,
        open: false,
      });
      this.homeProcedureName = "";
      this.homeCptCode = "";
      this.homeExamName = "";
      this.homeBodyPartName = "";
      this.homeinfosubmitNew = false;
      this.addProcedureList.examId = "";
      this.addProcedureList.bodyPartId = "";
      this.addProcedureList.bodyPartName = "";
      this.addProcedureList.cptCode = "";
      this.addProcedureList.procedureName = "";
      this.addProcedureList.procedureId = "";
      this.addProcedureList.procedureList = [];
      this.addProcedureList.procedureSelected = "";
      this.scrollTop("selectedexam");
      if (this.selectProcedureList.length >= 5) {
        this.showAddProcedureFormMob = false;
      } else {
        this.showAddProcedureFormMob = true;
      }

      this.searchSelectBodyPart = "";
      this.searchSelectExam = "";
      this.searchSelectProcedure = "";
      this.notfilled = false;
    } else {
      this.notfilled = true;
      this.toastr.error("Please fill all thefields");
    }
  }

  scrollTop(value) {
    document.getElementById(value).scrollIntoView({ behavior: "smooth" });
  }

  removeSelectProcedureListMob(index) {
    return this.homeSelectionShared.removeSelectProcedureListMob(this, index);
  }

  getallinsurancebyCountryCode(countryCode) {
    let data = {};
    if (countryCode === "IN") {
      this.placeholerCptCode = "Procedure";
      this.homeInsuranceType = 2;
      data = {
        countryId: 101,
      };
      this.getInsurance(data);
    } else {
      this.placeholerCptCode = "CPT Code";
      data = {
        countryId: 231,
      };
      this.getInsurance(data);
    }
  }

  onToggleCalendar(event: any): void {
    event.stopPropagation();
    this.mydp.openBtnClicked();
  }

  onDateChanged(event) {
    this.showErrDate = false;
    if (event && event.formatted) {
      this.homeDate = event.formatted;
    }
  }

  onCalendarToggle(event: number) {
    // console.log("onCalendarToggle(): Reason: ", event);
  }

  getCurrentIPAddress() {
    this.appservice.getCurrentIPAddress().subscribe((res) => {
      if (res && res["ip"]) {
        this.getAddressBasedonCurrentIp(res["ip"]);
      }
    });
  }

  getAddressBasedonCurrentIp(ip) {
    this.appservice.getAddressBasedonCurrentIp(ip).subscribe((res) => {
      let data = {};
      if (res && res["status"] === "success") {
        this.countryCode = res["countryCode"];
        if (res["countryCode"] === "IN") {
          this.placeholerCptCode = "Procedure";
          this.homeInsuranceType = 2;
          data = {
            countryId: 101,
          };
          this.getInsurance(data);
        } else if (res["countryCode"] === "US") {
          this.placeholerCptCode = "CPT Code";
          data = {
            countryId: 231,
          };
          this.getInsurance(data);
        }
      }
    });
  }

  validate(schedDate) {
    if (schedDate != null) {
      const validDate = moment(schedDate, "MMM DD,YYYY").isValid();
      if (validDate) {
        if (moment().diff(schedDate) <= 0) {
          this.showErrDate = false;
        } else {
          this.showErrDate = true;
        }
      } else {
        this.showErrDate = true;
      }
    }
  }

  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res && res["commonMsg"]) {
        this.selectedlang = res["commonMsg"];
      }
    });
  }

  formatHomeDateStr(date) {
    const datearray = date.toString().split("-");
    if (datearray.length > 0) {
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      let day = datearray[2];
      if (day && day.length < 1) {
        day = "0" + day;
      }
      const monthIndex = +datearray[1];
      const year = datearray[0];

      return monthNames[monthIndex - 1] + " " + day + "," + year;
    }
    return null;
  }

  formatHomeDate(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    let day = date.getDate();
    if (day && day < 10) {
      day = "0" + day;
    }
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return monthNames[monthIndex] + " " + day + "," + year;
  }

  showModal(): void {
    this.template.show();
  }

  hideModal(): void {
    this.template.hide();
  }

  addProcedure(type) {
    if (type === "new") {
      this.showModal();
    }
  }

  cptcodeChange(value) {
    if (value && value.toString().length === 5) {
      let isExist = false;
      if (this.selectProcedureList && this.selectProcedureList.length > 0) {
        for (let s = 0; s < this.selectProcedureList.length; s++) {
          if (this.selectProcedureList[s].cptCode === value) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          this.getallExamListOnchange(value);
        } else {
          this.toastr.error("Procedure already selected");
          this.blockAddMultipleProcedure = true;
          this.homeProcedureName = "";
          this.homeCptCode = "";
          this.addProcedureList.bodyPartId = "";
          this.homeBodyPartName = "";
          this.addProcedureList.examId = "";
          this.homeExamName = "";
        }
      }
    }
  }

  getallbodypartsbyexamonchange(examid) {
    const data = { examId: examid };
    this.appservice.getallbodypartsbyexamid(data).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 204) {
        this.toastr.error("bodypart is not available");
        this.addProcedureList.bodyPartId = "";
        this.homeBodyPartName = "";
      } else if (res && res["entity"]) {
        this.addProcedureList.bodyPartList = res["entity"];
        this.addProcedureList.procedureList = [];
        this.addProcedureList.bodyPartId = this.cptcodeobject["bodyPart"]["id"];
        this.homeBodyPartName = this.cptcodeobject["bodyPart"]["bodyPart"];
        this.addProcedureList.bodyPartName = this.cptcodeobject["bodyPart"][
          "bodyPart"
        ];
        this.homeCptCode = this.cptcodeobject["cptCode"];
        this.getallproceduresbybodypartbyonchange(
          this.addProcedureList.bodyPartId
        );
      }
    });
  }

  getallproceduresbybodypartbyonchange(bodypartId) {
    const data = {
      bodypartId: bodypartId,
    };
    this.appservice.getallproceduresbybodypart(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.addProcedureList.procedureList = res["entity"];
          for (let i = 0; i < res["entity"].length; i++) {
            if (res["entity"][i].id === this.cptcodeobject["id"]) {
              this.addProcedureList.procedureSelected = res["entity"][i];
              this.homeProcedureName = res["entity"][i].procedureName;
              this.blockAddMultipleProcedure = false;
            }
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallExamListOnchange(cptcode) {
    const data = { cptcode: cptcode };
    this.appservice
      .getallexamdandprocedureandbodypartbycptcodeForhome(data)
      .subscribe((res) => {
        if (res && res["status"]["status"] === 200) {
          if (
            res &&
            res["entity"] &&
            res["entity"]["bodyPart"] &&
            res["entity"]["bodyPart"]["exam"]
          ) {
            this.cptcodeobject = res["entity"];
            this.addProcedureList.examId =
              res["entity"]["bodyPart"]["exam"]["id"];
            this.homeExamName =
              res["entity"]["bodyPart"]["exam"]["examshortname"];
            this.addProcedureList.examName =
              res["entity"]["bodyPart"]["exam"]["examshortname"];

            this.getallbodypartsbyexamonchange(
              res["entity"]["bodyPart"]["exam"]["id"]
            );
          }
        } else if (res["status"]["status"] === 204) {
          this.toastr.error("Please check your cptcode");
          this.blockAddMultipleProcedure = true;
          this.homeProcedureName = "";
          this.homeCptCode = "";
          this.addProcedureList.bodyPartId = "";
          this.homeBodyPartName = "";
          this.addProcedureList.examId = "";
          this.homeExamName = "";
        }
      });
  }

  getInsurance(data) {
    if (data) {
      this.appservice.getallinsurancebycountry(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.insuranceList = res["entity"];
          }
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  getallexams() {
    this.appservice.getAllExams().subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.allExamList = res["entity"];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallbodypartsbyexamid() {
    const data = {
      examId: this.homeExamId,
    };
    this.appservice.getallbodypartsbyexamid(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.bodypartsList = res["entity"];
          if (this.allExamList && this.allExamList.length > 0) {
            for (let i = 0; i < this.allExamList.length; i++) {
              if (this.allExamList[i].id === this.homeExamId) {
                this.homeExamName = this.allExamList[i].examshortname;
                break;
              }
            }
          }
          this.homeBodyPartId = "";
          this.homeBodyPartName = "";
          this.homeProcedureName = "";
          this.homeCptCode = "";
          this.procedureList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  redirect() {
    this.router.navigate(["/home"]);
  }

  getallproceduresbybodypart(bodypartId) {
    const data = {
      bodypartId: bodypartId,
    };
    if (this.bodypartsList && this.bodypartsList.length > 0) {
      for (let i = 0; i < this.bodypartsList.length; i++) {
        if (this.bodypartsList[i].id === this.homeBodyPartId) {
          this.homeBodyPartName = this.bodypartsList[i].bodyPart;
          break;
        }
      }
    }
    this.appservice.getallproceduresbybodypart(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          for (let e = 0; e < res["entity"].length; e++) {
            res["entity"][e].checked = false;
          }
          this.procedureList = [];
          this.procedureList = res["entity"];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  deletepro(s) {
    this.selectProcedureList.splice(s, 1);
  }

  changeCptCode(procedure) {
    this.isExist = false;
    if (this.selectProcedureList && this.selectProcedureList.length > 0) {
      for (let s = 0; s < this.selectProcedureList.length; s++) {
        if (this.selectProcedureList[s].cptCode === procedure.cptCode) {
          this.isExist = true;
          break;
        }
      }
    }
    if (!this.isExist) {
      this.homeCptCode = procedure.cptCode;
      this.homeProcedureName = procedure.procedureName;
    }
  }

  scheduleMobileForm(data) {}

  blurHomeLocation() {
    this.homeLocation = this.homeLocationPlaceholder;
  }

  onChangeAddress(address) {
    let data = {};
    this.lat = address.geometry.location.lat();
    this.lng = address.geometry.location.lng();
    if (address && address["address_components"]) {
      this.homeLocation = address.adr_address.replace(/<[^>]{0,2000}>/g, "");
      this.timeZone = +address.utc_offset_minutes;
      for (
        let index = 0;
        index < address["address_components"].length;
        index++
      ) {
        if (address["address_components"][index]["types"][0] === "country") {
          if (
            address["address_components"][index]["long_name"] === "India" &&
            address["address_components"][index]["short_name"] === "IN"
          ) {
            if (
              this.countryCode !==
              address["address_components"][index]["short_name"]
            ) {
              this.countryCode = "IN";
              this.homeInsuranceType = "";
              this.homeInsuranceTypeName = "";
              this.homeInsuranceName = "";
              this.homeInsurance = "";
              data = {
                countryId: 101,
              };
              this.placeholerCptCode = "Procedure Name";
              this.insuranceList = [];
              this.getInsurance(data);
              if (!this.homeInsuranceName) {
                this.openInsuranceModal();
              }
            }
          } else {
            if (
              this.countryCode !==
              address["address_components"][index]["short_name"]
            ) {
              this.countryCode = "US";
              this.homeInsuranceType = "";
              this.homeInsuranceTypeName = "";
              this.homeInsuranceName = "";
              this.homeInsurance = "";
              data = {
                countryId: 231,
              };
              this.placeholerCptCode = "CPT Code";
              this.insuranceList = [];
              this.getInsurance(data);
              if (!this.homeInsuranceName) {
                this.openInsuranceModal();
              }
            }
          }
        }
      }

      this.homeLocation = "";
      address["address_components"].forEach((obj) => {
        obj.types.forEach((childObj) => {
          if (this.countryCode === "IN") {
            if (childObj === "sublocality_level_1") {
              this.homeLocation = obj.long_name;
            }
            if (
              childObj === "administrative_area_level_2" &&
              this.homeLocation
            ) {
              this.homeLocation = this.homeLocation + ", " + obj.long_name;
            }
            if (
              childObj === "administrative_area_level_2" &&
              this.homeLocation === ""
            ) {
              this.homeLocation = obj.long_name;
            }
            if (
              childObj === "administrative_area_level_1" &&
              this.homeLocation
            ) {
              this.homeLocation = this.homeLocation + ", " + obj.short_name;
            }
            if (
              childObj === "administrative_area_level_1" &&
              this.homeLocation === ""
            ) {
              this.homeLocation = obj.short_name;
            }
          } else {
            if (childObj === "locality") {
              this.homeLocation = obj.long_name;
            }
            if (
              childObj === "administrative_area_level_1" &&
              this.homeLocation
            ) {
              this.homeLocation = this.homeLocation + ", " + obj.short_name;
            }
            if (
              childObj === "administrative_area_level_1" &&
              this.homeLocation === ""
            ) {
              this.homeLocation = obj.short_name;
            }
          }
        });
      });
      this.homeLocationPlaceholder = "Location";
    }
  }

  callPopup(template) {
    this.openModal(template);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: "popup-center modal-xl",
    });
  }

  closePopup(): void {
    this.modalRef.hide();
  }

  yestriggerpopup() {}

  showProcedures() {
    this.showProcedure = true;
  }

  selectMultipleProcedure() {
    this.multiplePro = true;
    this.homeExamId = "";
    this.homeBodyPartId = "";
    this.bodypartsList = [];
    this.homeCptCode = "";
    this.homeExamName = "";
    this.homeBodyPartName = "";
    this.homeProcedureName = "";
    this.procedureList = [];
    this.template.hide();
  }

  changeHomeInsurance(ins) {
    if (ins === "self") {
      this.disabledInsType = true;
      this.homeInsuranceType = "";
      this.payMode = "self";
    } else {
      this.disabledInsType = false;
      this.payMode = "insurance";
      if (this.countryCode === "IN") {
        this.homeInsuranceType = 2;
      }
    }

    if (
      this.countryCode !== "IN" &&
      this.homeInsurance !== "self" &&
      !this.homeInsuranceType
    ) {
      this.openInsuranceTypeModal();
    }
  }

  navigatePatientProfileform() {
    this.pushScheduledData();
  }

  findpaymode() {
    if (this.homeInsurance === "self") {
      this.paymode = "self";
    } else {
      this.paymode = "insurance";
    }
  }

  findDay(day) {
    if (day === 0) {
      this.dayOfweek = "Sunday";
    }
    if (day === 1) {
      this.dayOfweek = "Monday";
    }
    if (day === 2) {
      this.dayOfweek = "Tuesday";
    }
    if (day === 3) {
      this.dayOfweek = "Wednesday";
    }
    if (day === 4) {
      this.dayOfweek = "Thursday";
    }
    if (day === 5) {
      this.dayOfweek = "Friday";
    }
    if (day === 6) {
      this.dayOfweek = "saturday";
    }
  }

  convetTimeZoneOffsetToTime() {
    return this.homeSelectionShared.convetTimeZoneOffsetToTime(this);
  }

  getRoundedDate = (minutes, d = new Date()) => {
    return this.homeSelectionShared.getRoundedDate(minutes, d);
  };

  pushScheduledData() {
    const scheduleOn = this.datePipe.transform(this.homeDate, "yyyy-MM-dd");
    this.findpaymode();
    if (
      this.homeDate &&
      this.homeLocation &&
      this.selectProcedureList &&
      this.selectProcedureList.length > 0
    ) {
      for (let i = 0; i < this.selectProcedureList.length; i++) {
        if (
          this.selectProcedureList[i].examId &&
          this.selectProcedureList[i].bodyPartId &&
          this.selectProcedureList[i].cptCode
        ) {
          this.cptCodeList.push(this.selectProcedureList[i].cptCode);
        }
      }
      const now = new Date();
      const zoneDate = new Date(
        now.getTime() + now.getTimezoneOffset() * 60000
      );
      zoneDate.setMinutes(
        zoneDate.getMinutes() +
          (this.timeZone ? this.timeZone : this.scheduledData.offsetmin) +
          15
      );
      const roundedDate = this.getRoundedDate(15, zoneDate);
      roundedDate.setSeconds(0);
      this.findDay(roundedDate.getDay());
      this.scheduledData = {
        scheduleId: this.scheduleappointmentid,
        scheduleOn: scheduleOn,
        scheduleOnStr: scheduleOn,
        dayOfweek: this.dayOfweek,
        location: this.homeLocation,
        insuranceId:
          this.homeInsurance &&
          this.homeInsurance !== "" &&
          this.homeInsurance !== "self"
            ? this.homeInsurance
            : 0,
        inType:
          this.homeInsuranceType && this.homeInsuranceType !== ""
            ? this.homeInsuranceType
            : 0,
        selectProcedureList: this.selectProcedureList,
        cptCodeList: this.cptCodeList,
        payMode: this.paymode,
        countryCode: this.countryCode,
        latitude: this.lat,
        longitude: this.lng,
        selectedExam: "",
        selectedExamId: "",
        today: this.datePipe.transform(roundedDate, "yyyy-MM-dd"),
        timeZone: "",
        offsetmin: this.timeZone ? this.timeZone : this.scheduledData.offsetmin,
        currentTime: this.datePipe.transform(roundedDate, "hh:mm aa"),
        homeInsuranceName: this.homeInsuranceName ? this.homeInsuranceName : "",
      };
      sessionStorage.setItem(
        "scheduleData",
        JSON.stringify(this.scheduledData)
      );
      if (this.scheduleappointmentid && this.scheduleappointmentid !== "") {
        this.router.navigate(["/profile-form", this.scheduleappointmentid]);
      } else {
        this.router.navigate(["/profile-form"]);
      }
    }
  }

  private isProcedureSelectionValid() {
    return this.homeSelectionShared.isProcedureSelectionValid(this);
  }

  scheduleFormSubmit(type) {
    if (this.selectProcedureList.length > 0) {
      if (
        this.addProcedureList.examId !== "" ||
        this.addProcedureList.bodyPartId !== "" ||
        this.addProcedureList.procedureSelected !== ""
      ) {
        this.addNewProcedureList(this.addProcedureList);
      }

      if (this.notfilled === false) {
        let valid = true;
        this.homeinfosubmit = true;
        if (this.countryCode === "IN") {
          if (!this.homeInsurance) {
            this.toastr.error("Please select insurance");
            return;
          }
          valid = this.isProcedureSelectionValid();
        }

        if (this.countryCode === "US") {
          if (!this.homeInsurance) {
            this.toastr.error("Please select insurance");
            return;
          }
          if (!this.homeInsuranceType && this.homeInsurance !== "self") {
            this.toastr.error("Please select insurance type");
            return;
          }
          valid = this.isProcedureSelectionValid();
        }

        if (valid) {
          if (this.homeInsuranceType === "") {
            this.homeInsuranceType = "2";
          }
          if (type !== "final") {
            this.selectMultipleProcedure();
          } else if (type === "final") {
            this.navigatePatientProfileform();
          }
        } else {
          this.toastr.error("Please fill all the fields.");
        }
      }
    } else {
      this.toastr.error("Please add atleast one Exam.");
    }
  }
}
